import { connect } from "react-redux";
import LoginView from "./LoginView";

import { clearLogoutQuery, loginToBlumira } from "../../redux/actions/Page";

const mapStateToProps = (state) => {
  const { redirect } = state.global;
  const { error } = state.page;
  const { payload = {}, meta = {}, query = {} } = state.location;
  return {
    show: error || redirect ? false : true,
    error,
    redirect,
    payload,
    query,
    meta,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatchClearLogoutQuery: () => dispatch(clearLogoutQuery),
  dispatchLoginToBlumira: ({ authResult, redirectPayload }) =>
    dispatch(loginToBlumira({ authResult, redirectPayload })),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginView);
